import * as InsurancePopup from './components/InsurancePopup.css';
import * as InsuranceCard from './components/InsuranceCard/InsuranceCard.css';

export default {
	InsurancePopup,
	InsuranceCard
};
